import React, { useState } from "react";
import { formatNumber } from "../../../../middleware/common-functions";
import { lang } from "../../../../middleware/lang";
import useSettings from "../../../../hooks/settings";

const SplitPayout = ({
  order,
  tip,
  splitPayments,
  onPaySplit,
  onRemoveSplit,
  onCancel,
  onFinalize,
  paying,
}) => {
  const [settings] = useSettings();
  const [amount, setAmount] = useState("");
  const [paymentType, setPaymentType] = useState("cash");
  const [cardType, setCardType] = useState(undefined);
  const [splitCount, setSplitCount] = useState("");
  const [showSplitHelper, setShowSplitHelper] = useState(false);

  const grandTotal = order.total + (tip || 0);
  const totalPaid = splitPayments.reduce((sum, p) => sum + p.amount, 0);
  const remaining = grandTotal - totalPaid;
  const fullyPaid = remaining <= 0.01;

  const handleAddUp = (add) => {
    let current = amount;
    if (isNaN(add) && add !== ".") {
      current = current.slice(0, -1);
    } else {
      current = current + add;
    }
    setAmount(current);
  };

  const handleSetPaymentType = (ev) => {
    const type = ev.currentTarget.dataset.type;
    const card = ev.currentTarget.dataset.card;
    setPaymentType(type);
    setCardType(card || undefined);
  };

  const handleAddPayment = () => {
    const parsedAmount = parseFloat(amount);
    if (!parsedAmount || parsedAmount <= 0) return;
    const payAmount = Math.min(parsedAmount, remaining);
    onPaySplit(payAmount, paymentType, cardType);
    setAmount("");
  };

  const handleEqualSplit = () => {
    const count = parseInt(splitCount);
    if (!count || count < 2) return;
    const perPerson = Math.ceil((remaining * 100) / count) / 100;
    setAmount(perPerson.toString());
    setShowSplitHelper(false);
    setSplitCount("");
  };

  const paymentLabel = (type, card) => {
    if (type === "terminal" && card === "debit") return "TD";
    if (type === "terminal" && card === "credit") return "TC";
    if (type === "terminal") return "Terminal";
    return "Efectivo";
  };

  return (
    <div className="container-fluid py-2">
      <div className="row charge_div">
        <div className="col p-1">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h5 className="m-0">
              Total: <b>${formatNumber(grandTotal)}</b>
            </h5>
            <h5 className="m-0 text-danger">
              {lang("Restante", "Remaining")}:{" "}
              <b>${formatNumber(Math.max(remaining, 0))}</b>
            </h5>
          </div>

          {tip > 0 && (
            <h6 className="text-center text-success m-0 mb-1">
              {lang("Propina incluida", "Tip included")}: $
              {formatNumber(tip)}
            </h6>
          )}

          <hr className="my-1" />

          {splitPayments.length > 0 && (
            <div className="mb-2">
              <h6 className="mb-1">
                <b>{lang("Pagos realizados", "Payments made")}</b>
              </h6>
              {splitPayments.map((p, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center py-1 border-bottom"
                >
                  <span>
                    {lang("Pago", "Payment")} {i + 1}
                  </span>
                  <span className="d-flex align-items-center">
                    <span className="badge badge-secondary mr-2">
                      {paymentLabel(p.payment_type, p.card_type)}
                    </span>
                    <b className="mr-2">${formatNumber(p.amount)}</b>
                    <button
                      className="btn btn-sm btn-link text-danger p-0"
                      onClick={() => onRemoveSplit(i)}
                      title={lang("Quitar", "Remove")}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </span>
                </div>
              ))}
            </div>
          )}

          {!fullyPaid && (
            <>
              <h6 className="text-center mb-0">
                {lang("Monto del pago", "Payment amount")}
              </h6>
              <h5 className="my-1 fa-2x text-center">
                $<span className="cash">{amount || 0}</span>
              </h5>

              {showSplitHelper ? (
                <div className="d-flex align-items-center justify-content-center mb-2">
                  <input
                    type="number"
                    className="form-control form-control-sm mr-2"
                    style={{ maxWidth: 80 }}
                    placeholder="# partes"
                    value={splitCount}
                    onChange={(e) => setSplitCount(e.target.value)}
                    min="2"
                    autoFocus
                  />
                  <button
                    className="btn btn-sm btn-info mr-1"
                    onClick={handleEqualSplit}
                    disabled={!splitCount || parseInt(splitCount) < 2}
                  >
                    {lang("Dividir", "Split")}
                  </button>
                  <button
                    className="btn btn-sm btn-link"
                    onClick={() => {
                      setShowSplitHelper(false);
                      setSplitCount("");
                    }}
                  >
                    {lang("Cancelar", "Cancel")}
                  </button>
                </div>
              ) : (
                <div className="text-center mb-2">
                  <button
                    className="btn btn-sm btn-outline-info"
                    onClick={() => setShowSplitHelper(true)}
                  >
                    <i className="fas fa-divide mr-1"></i>
                    {lang("Dividir en partes iguales", "Split equally")}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {!fullyPaid && (
        <div className="calulcator_numbers animate_all">
          <div className="row calc_container justify-content-between">
            <div className="col-md-12">
              <div className="row h-100 align-items-stretch">
                {settings.cards_type ? (
                  <>
                    <SplitPaymentBtn
                      onClick={handleSetPaymentType}
                      selected={
                        paymentType === "terminal" && cardType === "debit"
                      }
                      type="terminal"
                      card_type="debit"
                      text="Tarjeta de débito"
                      text_xs="TD"
                      icon="fas fa-credit-card"
                    />
                    <SplitPaymentBtn
                      onClick={handleSetPaymentType}
                      selected={
                        paymentType === "terminal" && cardType === "credit"
                      }
                      type="terminal"
                      card_type="credit"
                      text="Tarjeta de crédito"
                      text_xs="TC"
                      icon="fas fa-credit-card"
                    />
                  </>
                ) : (
                  <SplitPaymentBtn
                    onClick={handleSetPaymentType}
                    selected={paymentType === "terminal"}
                    type="terminal"
                    text="Pagado con Terminal"
                    text_xs="Terminal"
                    icon="fas fa-credit-card"
                  />
                )}
                <SplitPaymentBtn
                  onClick={handleSetPaymentType}
                  selected={paymentType === "cash"}
                  type="cash"
                  text="Efectivo"
                  text_xs="Efectivo"
                  icon="fas fa-money-bill-wave"
                />
              </div>
            </div>

            <div className="col-md-3 align-items-stretch xs_hidden">
              <button
                type="button"
                className="btn btn-link btn-block py-3 py-xl-4 btn_xs_lg_mob h-100"
                onClick={onCancel}
              >
                {lang("Cancelar", "Cancel")}
              </button>
            </div>

            <div className="col-md-5">
              <div className="row">
                {renderButtons(handleAddUp)}
                <SplitButton num="." addUp={handleAddUp} secondary />
                <SplitButton num="0" addUp={handleAddUp} />
                <SplitButton
                  icon="fas fa-caret-left"
                  addUp={handleAddUp}
                  secondary
                />
              </div>
            </div>

            <div className="col-md-3 payout_div">
              <button
                type="button"
                className={`btn btn-block py-3 py-xl-4 btn_xs_lg_mob h-100 border_btn ${
                  amount && parseFloat(amount) > 0
                    ? "btn-outline-primary"
                    : "btn-danger"
                }`}
                onClick={handleAddPayment}
                disabled={
                  !amount || parseFloat(amount) <= 0 || paying
                }
              >
                {paying ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  lang("Agregar Pago", "Add Payment")
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {fullyPaid && (
        <div className="text-center mt-3">
          <button
            className="btn btn-success btn-lg btn-block py-3"
            onClick={onFinalize}
            disabled={paying}
          >
            {paying ? (
              <i className="fas fa-spinner fa-spin mr-2"></i>
            ) : (
              <i className="fas fa-check mr-2"></i>
            )}
            {lang("Completar Cobro", "Complete Payment")}
          </button>
        </div>
      )}
    </div>
  );
};

const SplitButton = ({ addUp, icon, num, secondary }) => {
  const display = icon ? <i className={icon}></i> : num;
  const classes = ["btn btn-outline-dark btn-block py-3 py-xl-4"];
  const val = icon ? "rest" : num;
  if (secondary) classes.push("btn_secondary");

  return (
    <div className="col-4 p-1 m-0">
      <button
        type="button"
        className={classes.join(" ")}
        onClick={() => addUp(val)}
      >
        {display}
      </button>
    </div>
  );
};

function renderButtons(addUp) {
  const buttons = [];
  for (let index = 1; index <= 9; index++) {
    buttons.push(<SplitButton addUp={addUp} key={index} num={index} />);
  }
  return buttons;
}

const SplitPaymentBtn = ({
  onClick,
  selected,
  type,
  card_type,
  text,
  text_xs,
  icon,
}) => (
  <div className="col pl-0 pr-1 py-1 m-0">
    <button
      type="button"
      className={`btn ${
        selected ? "btn-dark" : ""
      } btn-block py-3 py-xl-4 btn_xs_lg_mob h-100`}
      data-type={type}
      data-card={card_type}
      onClick={onClick}
    >
      <i className={`mr-2 ${icon}`}></i>
      <span className="xs_hidden">{text}</span>
      <span className="d-sm-none">{text_xs}</span>
    </button>
  </div>
);

export default SplitPayout;
